import { api } from '@services';
import { Convert } from '@utils';

const generateType = (actionType = 'CUSTOM', reducer = 'PAGE/ADMINRECEPTION') => `${reducer}/${actionType}`;

export const fetchAll = () => {
	return async (dispatch, getState) => {
		const { from, size } = getState().page.adminReception.fetchAll;

		const onOK = async (res) => {
			const $list = res.info.DATA || [];
			const total = res.info.COUNT || 10;

			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					fetchAll: {
						...getState().page.adminReception.fetchAll,
						$list,
						total,
					},
				},
			});
		};

		const onFail = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					fetchAll: {
						...getState().page.adminReception.fetchAll,
						$list: [],
					},
				},
			});
		};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					fetchAll: {
						...getState().page.adminReception.fetchAll,
						_list: status,
					},
				},
			});
		};

		api.$turn_fetchAll({ onOK, onFail, onStatus }, { from, to: size + from - 1 });
	};
};

export const saveTurn = () => {
	return async (dispatch, getState) => {
		const { date, time } = getState().page.adminReception.addTurn;
		const convertDate = () => {
			return Convert.newDateToFaDate(date);
		};

		const convertTime = () => {
			let h = new Date(time).getHours();
			let m = new Date(time).getMinutes();

			return `${h >= 10 ? h : `0${h}`}:${m >= 10 ? m : `0${m}`}:00`;
		};

		const turn = `${convertDate()} ${convertTime()}`;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					addTurn: {
						...getState().page.adminReception.addTurn,
						show: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					addTurn: {
						...getState().page.adminReception.addTurn,
						_add: status,
					},
				},
			});
		};

		api.$turn_save({ onOK, onFail, onStatus, showOkMessage: true }, { turn });
	};
};

export const editTimeTurn = () => {
	return async (dispatch, getState) => {
		const { date, time, id } = getState().page.adminReception.editTurn;

		const convertDate = () => {
			return Convert.newDateToFaDate(date);
		};

		const convertTime = () => {
			let h = new Date(time).getHours();
			let m = new Date(time).getMinutes();

			return `${h >= 10 ? h : `0${h}`}:${m >= 10 ? m : `0${m}`}:00`;
		};

		const turn = `${convertDate()} ${convertTime()}`;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					editTurn: {
						...getState().page.adminReception.editTurn,
						show: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					editTurn: {
						...getState().page.adminReception.editTurn,
						_edit: status,
					},
				},
			});
		};

		api.$turn_edit({ onOK, onFail, onStatus, showOkMessage: true }, { id, turn });
	};
};

export const editAttemptedTurn = () => {
	return async (dispatch, getState) => {
		const { id, isAttempted } = getState().page.adminReception.infoUser;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					infoUser: {
						...getState().page.adminReception.infoUser,
						show: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					infoUser: {
						...getState().page.adminReception.infoUser,
						_info: status,
					},
				},
			});
		};

		api.$turn_edit({ onOK, onFail, onStatus, showOkMessage: true }, { id, isAttempted: isAttempted.value });
	};
};

export const removeUser = () => {
	return async (dispatch, getState) => {
		const { id } = getState().page.adminReception.removeUser;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					removeUser: {
						...getState().page.adminReception.removeUser,
						show: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					removeUser: {
						...getState().page.adminReception.removeUser,
						_remove: status,
					},
				},
			});
		};

		api.$turn_removeUser({ onOK, onFail, onStatus, showOkMessage: true }, { id });
	};
};

export const removeTurn = () => {
	return async (dispatch, getState) => {
		const { id } = getState().page.adminReception.removeTurn;

		const onOK = async (res) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					removeTurn: {
						...getState().page.adminReception.removeTurn,
						show: false,
					},
				},
			});

			await dispatch(fetchAll());
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					removeTurn: {
						...getState().page.adminReception.removeTurn,
						_remove: status,
					},
				},
			});
		};

		api.$turn_removeTurn({ onOK, onFail, onStatus, showOkMessage: true }, { id });
	};
};

export const turnGetId = () => {
	return async (dispatch, getState) => {
		const { id } = getState().page.adminReception.infoUser;

		const onOK = async (res) => {
			const info = res?.info || null;
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					infoUser: {
						...getState().page.adminReception.infoUser,
						info,
					},
				},
			});
		};

		const onFail = async (res) => {};

		const onStatus = async (status) => {
			await dispatch({
				type: generateType('CUSTOM'),
				payload: {
					...getState().page.adminReception,
					infoUser: {
						...getState().page.adminReception.infoUser,
						_info: status,
					},
				},
			});
		};

		api.$turn_getId({ onOK, onFail, onStatus }, { id });
	};
};
